/** Maximum number of characters allowed in a message body (markdown length). */
export const MAX_MESSAGE_LENGTH = 2048;
